var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoteitLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 843.9 843.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "favicon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noteitfull"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.35,843.9c-13.44,0-25.08-10.03-26.76-23.71L.2,116.67c-.87-7.11,1.11-14.27,5.52-19.91,4.41-5.64,10.88-9.3,17.99-10.18L727.22,.2c7.1-.87,14.27,1.11,19.91,5.52,5.64,4.41,9.3,10.88,10.18,17.99l86.38,703.51c1.82,14.8-8.71,28.27-23.51,30.09L116.67,843.69c-1.12,.14-2.23,.2-3.32,.2ZM57.09,136.89l79.8,649.92,649.92-79.8L707.01,57.09,57.09,136.89Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteitLogo);
export default __webpack_public_path__ + "static/media/noteit_logo.c157c83bf4c4c8f7c1926c7bf31336fc.svg";
export { ForwardRef as ReactComponent };